import * as React from "react";

function ConectaZapDeviceIcon(props) {
  return (
    <svg
      width={98}
      height={102}
      viewBox="0 0 98 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M.75.681v90.574h48.5V87.9H3.983V10.745h80.834v16.773h3.233V.68H.75zm6.467 6.71H3.983V4.035h3.234V7.39zm6.466 0H10.45V4.035h3.233V7.39zm6.467 0h-3.233V4.035h3.233V7.39z"
        fill="#0036B3"
      />
      <path
        d="M92.9 30.873H57.333c-2.748 0-4.85 2.18-4.85 5.031v60.383c0 2.851 2.102 5.032 4.85 5.032H92.9c2.748 0 4.85-2.18 4.85-5.032V35.904c0-2.851-2.102-5.031-4.85-5.031zm-27.483 3.354h19.4c.97 0 1.616.671 1.616 1.677 0 1.007-.646 1.678-1.616 1.678h-19.4c-.97 0-1.617-.671-1.617-1.678 0-1.006.647-1.677 1.617-1.677zm9.7 63.737c-1.779 0-3.234-1.51-3.234-3.354 0-1.845 1.455-3.355 3.234-3.355 1.778 0 3.233 1.51 3.233 3.355s-1.455 3.354-3.233 3.354zm19.4-10.064h-38.8V40.936h38.8V87.9z"
        fill="#0036B3"
      />
    </svg>
  );
}

export default ConectaZapDeviceIcon;
